import * as React from 'react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from './ui/dialog'
import { getCurrentDirection } from '@/i18n/config'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title?: React.ReactNode
  description?: string
  children: React.ReactNode
  footer?: React.ReactNode
  className?: string
  overlayClassName?: string
  preventOutsideClose?: boolean
  showCloseButton?: boolean
  headerActions?: React.ReactNode
}

const Modal = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  footer,
  className,
  overlayClassName,
  preventOutsideClose = false,
  showCloseButton = false,
  headerActions,
}: ModalProps) => {
  const isRTL = getCurrentDirection() === 'rtl'

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && !preventOutsideClose && onClose()} modal>
      <DialogContent
        className={className}
        overlayClassName={overlayClassName}
        hideDefaultClose={!showCloseButton}
        headerActions={headerActions}
        dir={isRTL ? 'rtl' : 'ltr'}
        onInteractOutside={(e) => preventOutsideClose && e.preventDefault()}
        onEscapeKeyDown={(e) => preventOutsideClose && e.preventDefault()}
      >
        {title ? (
          <div className="flex flex-col items-start text-start">
            <DialogTitle className="text-lg font-semibold leading-none tracking-tight">
              {title}
            </DialogTitle>
            {description && (
              <DialogDescription className="text-sm text-muted-foreground mt-1">
                {description}
              </DialogDescription>
            )}
          </div>
        ) : (
          <DialogTitle className="sr-only">Dialog</DialogTitle>
        )}
        <div className="text-start">{children}</div>
        {footer && (
          <DialogFooter className={`gap-2 `}>
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default Modal
